export default __webpack_public_path__ + "static/media/notification-active.8ae500a2.svg";